/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ActionType, createAction} from 'typesafe-actions';
import {
	EnterPasswordForFlexServiceWorkerRegistrationDTO,
	EnterPhoneNumberForFlexServiceWorkerRegistrationDTO,
	EnterPhoneVerificationCodeForFlexServiceWorkerRegistrationDTO,
	FlexServiceWorkerRegistrationPasswordStrengthEvaluationRequestDTO,
	FlexServiceWorkerRegistrationStateDTO,
	PasswordStrengthDTO,
	PhoneNumberDTO
} from '../../generated/iam-client';
import {Country} from '../../model/country';
import {ConstraintViolationDTO} from '../../model/validation';

export const flexServiceWorkerRegistrationSceneActivated =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ACTIVATED')();

export const flexServiceWorkerRegistrationSceneDeactivated =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_DEACTIVATED')();

export const flexServiceWorkerRegistrationSceneStateRetrieved =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_RETRIEVED')<{ state: FlexServiceWorkerRegistrationStateDTO }>();

export const flexServiceWorkerRegistrationSceneStateNotFound =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_NOT_FOUND')();

export const flexServiceWorkerRegistrationSceneStateUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationScenePhoneNumberLookupInputChanged =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PHONE_NUMBER_LOOKUP_INPUT_CHANGED')<{ country: Country, phoneNumber: string }>();

export const flexServiceWorkerRegistrationScenePhoneNumberLookupResolved =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PHONE_NUMBER_LOOKUP_RESOLVED')<{ phoneNumber: PhoneNumberDTO }>();

export const flexServiceWorkerRegistrationScenePerformPhoneNumberLookupUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PERFORM_PHONE_NUMBER_LOOKUP_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationScenePhoneNumberLookupSubmitted =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PHONE_NUMBER_LOOKUP_SUBMITTED')<{
		command: EnterPhoneNumberForFlexServiceWorkerRegistrationDTO
	}>();

export const flexServiceWorkerRegistrationScenePhoneNumberEntered =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PHONE_NUMBER_ENTERED')();

export const flexServiceWorkerRegistrationSceneEnterPhoneNumberNotFound =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PHONE_NUMBER_NOT_FOUND')();

export const flexServiceWorkerRegistrationSceneEnterPhoneNumberValidationException =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PHONE_NUMBER_VALIDATION_EXCEPTION')<{
		violations: { [key: string]: ConstraintViolationDTO[] }
	}>();

export const flexServiceWorkerRegistrationSceneEnterPhoneNumberUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PHONE_NUMBER_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationSceneRequestStopPhoneVerification =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_REQUEST_STOP_PHONE_VERIFICATION')();

export const flexServiceWorkerRegistrationSceneStopPhoneVerificationRequested =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_STOP_PHONE_VERIFICATION_REQUESTED')();

export const flexServiceWorkerRegistrationSceneStopPhoneVerificationNotFound =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_STOP_PHONE_VERIFICATION_NOT_FOUND')();

export const flexServiceWorkerRegistrationSceneStopPhoneVerificationUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_STOP_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationScenePhoneVerificationCodeInputChanged =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PHONE_VERIFICATION_CODE_INPUT_CHANGED')<{ verificationCode: string }>();

export const flexServiceWorkerRegistrationScenePhoneVerificationCodeSubmitted =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PHONE_VERIFICATION_CODE_SUBMITTED')<{
		command: EnterPhoneVerificationCodeForFlexServiceWorkerRegistrationDTO
	}>();

export const flexServiceWorkerRegistrationScenePhoneVerificationCodeEntered =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PHONE_VERIFICATION_CODE_ENTERED')();

export const flexServiceWorkerRegistrationSceneEnterPhoneVerificationCodeNotFound =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PHONE_VERIFICATION_CODE_NOT_FOUND')();

export const flexServiceWorkerRegistrationSceneEnterPhoneVerificationCodeValidationException =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PHONE_VERIFICATION_CODE_VALIDATION_EXCEPTION')<{
		violations: { [key: string]: ConstraintViolationDTO[] }
	}>();

export const flexServiceWorkerRegistrationSceneEnterPhoneVerificationCodeUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PHONE_VERIFICATION_CODE_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationSceneRequestResolvePersonalName =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_REQUEST_RESOLVE_PERSONAL_NAME')();

export const flexServiceWorkerRegistrationSceneResolvePersonalNameRequested =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_RESOLVE_PERSONAL_NAME_REQUESTED')();

export const flexServiceWorkerRegistrationSceneResolvePersonalNameNotFound =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_RESOLVE_PERSONAL_NAME_NOT_FOUND')();

export const flexServiceWorkerRegistrationSceneResolvePersonalNameUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_RESOLVE_PERSONAL_NAME_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationScenePasswordInputChanged =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PASSWORD_INPUT_CHANGED')<{
		evaluationRequest: FlexServiceWorkerRegistrationPasswordStrengthEvaluationRequestDTO
	}>();

export const flexServiceWorkerRegistrationScenePasswordStrengthEvaluated =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PASSWORD_STRENGTH_EVALUATED')<{ passwordStrength: PasswordStrengthDTO }>();

export const flexServiceWorkerRegistrationSceneEvaluatePasswordStrengthNotFound =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_EVALUATE_PASSWORD_STRENGTH_NOT_FOUND')();

export const flexServiceWorkerRegistrationSceneEvaluatePasswordStrengthUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_EVALUATE_PASSWORD_STRENGTH_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationScenePasswordSubmitted =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PASSWORD_SUBMITTED')<{
		command: EnterPasswordForFlexServiceWorkerRegistrationDTO
	}>();

export const flexServiceWorkerRegistrationScenePasswordEntered =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_PASSWORD_ENTERED')();

export const flexServiceWorkerRegistrationSceneEnterPasswordNotFound =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PASSWORD_NOT_FOUND')();

export const flexServiceWorkerRegistrationSceneEnterPasswordValidationException =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PASSWORD_VALIDATION_EXCEPTION')<{
		violations: { [key: string]: ConstraintViolationDTO[] }
	}>();

export const flexServiceWorkerRegistrationSceneEnterPasswordUnexpectedError =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_ENTER_PASSWORD_UNEXPECTED_ERROR')();

export const flexServiceWorkerRegistrationSceneStateChanged =
	createAction('FLEX_SERVICE_WORKER_REGISTRATION_SCENE_STATE_CHANGED')<{ state: FlexServiceWorkerRegistrationStateDTO }>();

// noinspection DuplicatedCode
export type ActionTypes =
	ActionType<typeof flexServiceWorkerRegistrationSceneActivated> |
	ActionType<typeof flexServiceWorkerRegistrationSceneDeactivated> |
	ActionType<typeof flexServiceWorkerRegistrationSceneStateRetrieved> |
	ActionType<typeof flexServiceWorkerRegistrationSceneStateNotFound> |
	ActionType<typeof flexServiceWorkerRegistrationSceneStateUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationScenePhoneNumberLookupInputChanged> |
	ActionType<typeof flexServiceWorkerRegistrationScenePhoneNumberLookupResolved> |
	ActionType<typeof flexServiceWorkerRegistrationScenePerformPhoneNumberLookupUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationScenePhoneNumberLookupSubmitted> |
	ActionType<typeof flexServiceWorkerRegistrationScenePhoneNumberEntered> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPhoneNumberNotFound> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPhoneNumberValidationException> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPhoneNumberUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationSceneRequestStopPhoneVerification> |
	ActionType<typeof flexServiceWorkerRegistrationSceneStopPhoneVerificationRequested> |
	ActionType<typeof flexServiceWorkerRegistrationSceneStopPhoneVerificationNotFound> |
	ActionType<typeof flexServiceWorkerRegistrationSceneStopPhoneVerificationUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationScenePhoneVerificationCodeInputChanged> |
	ActionType<typeof flexServiceWorkerRegistrationScenePhoneVerificationCodeSubmitted> |
	ActionType<typeof flexServiceWorkerRegistrationScenePhoneVerificationCodeEntered> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPhoneVerificationCodeNotFound> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPhoneVerificationCodeValidationException> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPhoneVerificationCodeUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationSceneRequestResolvePersonalName> |
	ActionType<typeof flexServiceWorkerRegistrationSceneResolvePersonalNameRequested> |
	ActionType<typeof flexServiceWorkerRegistrationSceneResolvePersonalNameNotFound> |
	ActionType<typeof flexServiceWorkerRegistrationSceneResolvePersonalNameUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationScenePasswordInputChanged> |
	ActionType<typeof flexServiceWorkerRegistrationScenePasswordStrengthEvaluated> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEvaluatePasswordStrengthNotFound> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEvaluatePasswordStrengthUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationScenePasswordSubmitted> |
	ActionType<typeof flexServiceWorkerRegistrationScenePasswordEntered> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPasswordNotFound> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPasswordValidationException> |
	ActionType<typeof flexServiceWorkerRegistrationSceneEnterPasswordUnexpectedError> |
	ActionType<typeof flexServiceWorkerRegistrationSceneStateChanged>;
